import React from "react"
import styled, { keyframes } from "styled-components"
import HeroSection from "../../components/HeroSection/HeroSection"
import AccueilSchemaSection from "./AccueilSchemaSection.jsx"
import AccueilPresentationSection from "./AccueilPresentationSection.jsx"
import BannerDevis from "../../components/BannerDevis/BannerDevis.jsx"
import {
    MainContainer,
    CenterTitle,
    Title,
} from "../../utils/style/elements.tsx"
import ProjectList from "../../components/ProjectList/ProjectList.tsx"
import projectData from "../../datas/projectData"
import { useScrollReveal } from "../../utils/hooks/useScrollReveal"

// Animation de fade in + slide up
const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(50px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

// Wrapper animé
const AnimatedSection = styled.div`
    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    animation: ${({ $isVisible }) => ($isVisible ? fadeInUp : 'none')} 0.8s ease-out;
`

const SectionServices = styled.div``
const SectionPresentation = styled.div``
const SectionBanner = styled.div``

const SectionProcessus = styled.div`
    margin-bottom: 5vw;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 110%;
    margin-left: -5%;
`

function Accueil() {
    const [refServices, isVisibleServices] = useScrollReveal({ once: true, threshold: 0.2 })
    const [refPresentation, isVisiblePresentation] = useScrollReveal({ once: true, threshold: 0.2 })
    const [refProjects, isVisibleProjects] = useScrollReveal({ once: true, threshold: 0.2 })
    const [refBanner, isVisibleBanner] = useScrollReveal({ once: true, threshold: 0.2 })

    return (
        <React.StrictMode>
            <HeroSection page="accueil" />
            <MainContainer>
                <AnimatedSection ref={refServices} $isVisible={isVisibleServices}>
                    <SectionServices id="mesServices">
                        <CenterTitle>
                            <Title>Mes services</Title>
                        </CenterTitle>
                        <AccueilSchemaSection />
                    </SectionServices>
                </AnimatedSection>

                <AnimatedSection ref={refPresentation} $isVisible={isVisiblePresentation}>
                    <SectionPresentation id="quiSuisJe">
                        <CenterTitle>
                            <Title>Qui suis-je ?</Title>
                        </CenterTitle>
                        <AccueilPresentationSection />
                    </SectionPresentation>
                </AnimatedSection>

                <AnimatedSection ref={refProjects} $isVisible={isVisibleProjects}>
                    <SectionProcessus>
                        <CenterTitle>
                            <Title>Quelques projets</Title>
                        </CenterTitle>
                        <ProjectList projects={projectData} />
                    </SectionProcessus>
                </AnimatedSection>

                <AnimatedSection ref={refBanner} $isVisible={isVisibleBanner}>
                    <SectionBanner>
                        <BannerDevis />
                    </SectionBanner>
                </AnimatedSection>
            </MainContainer>
        </React.StrictMode>
    )
}

export default Accueil